module.exports = __webpack_public_path__ + "img/yzf_grey.de0c5c39.png";